import Tooltip from '@/components/Tooltip';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import type { ReactNode } from 'react';
import { useId } from 'react';

type Props = {
  children: ReactNode;
  tooltip?: ReactNode;
};

export const TitleWithTooltip = ({ children, tooltip }: Props) => {
  const tooltipId = useId();
  return (
    <div className="grid grid-cols-[minmax(min-content,max-content)_min-content] items-center gap-1">
      <div className="text-xs text-solid sm:text-sm">{children}</div>
      {tooltip && (
        <Tooltip title={<div id={tooltipId}>{tooltip}</div>} zIndex={10000}>
          <button
            aria-describedby={tooltipId}
            aria-label="Info tooltip"
            tabIndex={0}
          >
            <InformationSolid className="fill-softer" />
          </button>
        </Tooltip>
      )}
    </div>
  );
};
